import type { FaireProductEntity } from "../../entity_types/product";

export const p_e9a7d53gec: FaireProductEntity = {
  token: "p_e9a7d53gec",
  type: "product",
  name: "Best Human Mom | Mother's Day from Dog Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/c555e60dacc988b9e09fe3c0523954471a7817c9245063db62f4c95d52f5747c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f802988b160d38b3214f37f7a78420d46c1adddca0e3bab53d5f60e2632f0f3.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:15.959Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
